<main>
  <loading-overlay [isLoading]="isLoading() > 0"></loading-overlay>
  <div class="content">
    <div class="page__title">
      <div class="page__title_container">
        <h1>{{ 'Step_Title' | translateWF: 'Steps' }}</h1>
        <div class="page__title_buttons">
          @if (canEdit()) {
            <p-button [label]="'Common_Add' | translateWF: 'Add'" icon="pi pi-plus" (click)="redirectToDetails()" />
          }
        </div>
      </div>
    </div>
    <section>
      <div class="cs-page-list-grid">
        @if (filterConfig() && showFilters()) {
          <csl-dynamic-filters [filterConfig]="filterConfig()!" [state]="filterState" />
        }

        <p-panel [header]="'Step_Title' | translateWF: 'Steps'">
          <ng-template pTemplate="icons">
            <p-button
              [label]="(showFilters() ? 'Common_Hide_Filters' : 'Common_Show_Filters') | translateWF: (showFilters() ? 'Hide Filters' : 'Show Filters')"
              [icon]="showFilters() ? 'pi pi-filter-slash' : 'pi pi-filter'"
              (click)="showFilters.set(!showFilters())"
              variant="outlined"
              size="small"
            />
          </ng-template>
          <p-card data-variant="compact">
            <p-table [value]="steps" [paginator]="true" [rows]="15" selectionMode="single">
              <ng-template pTemplate="header">
                <tr class="primary__header">
                  <th pSortableColumn="stepId">
                    {{ 'Step_ID' | translateWF: 'Step ID' }}
                    <p-sortIcon field="stepId" />
                  </th>
                  <th pSortableColumn="name">
                    {{ 'Step_Name' | translateWF: 'Name' }}
                    <p-sortIcon field="name" />
                  </th>
                </tr>
              </ng-template>
              <ng-template pTemplate="body" let-step>
                @let strictStep = StrictStep(step);
                <tr class="cursor-pointer" (click)="redirectToDetails(strictStep.stepId)">
                  <td class="max-w-[12.5rem] truncate">
                    <a>
                      {{ strictStep.stepId }}
                    </a>
                  </td>
                  <td>{{ strictStep.name | localized }}</td>
                </tr>
              </ng-template>
            </p-table>
          </p-card>
        </p-panel>
      </div>
    </section>
  </div>
</main>
